import getJSON from '~/js/helpers/xhr'
import Highcharts from 'highcharts/highstock'

const ChartBlock = document.querySelector(`.js-premium-discount-chart`)
let resId = null;
if (ChartBlock) {
  resId = ChartBlock.getAttribute(`data-res-id`)
}

const now = new Date().getTime();
const month = new Date().getMonth();
const currentYear = new Date().getFullYear();
const prevYear = currentYear - 1;
const firstDayOfCurrentYear = new Date(currentYear, 0, 1).getTime();
let firstDayOfPrevYear = new Date(prevYear, 0, 1).getTime();
const Difference_In_Days_PYTD = Math.floor( ( now - firstDayOfPrevYear ) / ( 1000 * 3600 * 24 ) ) - 1;

const startOfPrevQ = new Date(currentYear, Math.floor(month / 3) * 3 - 3, 1).getTime() + 21600000;
const endOfPrevQ = new Date(currentYear, Math.floor(month / 3) * 3, 0).getTime();
const Difference_In_Days_PQ = Math.floor( ( endOfPrevQ - startOfPrevQ ) / ( 1000 * 3600 * 24 ) )

/* смещение на 6 часов из-за часовых поясов */
if ( month <=3 ) {
  document.querySelectorAll('.js-q2-cell').forEach((q)=>{
    q.style.display = 'none'
  })
  document.querySelectorAll('.js-q3-cell').forEach((q)=>{
    q.style.display = 'none'
  })
  if (document.querySelector('.js-table-growth')) {
    document.querySelector('.js-table-growth').style = 'grid-template-columns: 40% 30% 30%'
  }
} else if ( month <=5 ) {
  document.querySelectorAll('.js-q3-cell').forEach((q)=>{
    q.style.display = 'none'
  })
  if (document.querySelector('.js-table-growth')) {
    document.querySelector('.js-table-growth').style = 'grid-template-columns: 25% 25% 25% 25%'
  }
}

getJSON(`assets/components/dohod/connectorweb.php?action=PremiumDiscount/get&resId=${resId}`).then((data) => {

  if (document.querySelector('.year-premium')) {
    document.querySelector('.year-premium').innerText = data.yearItems.premium
  }
  if (document.querySelector('.year-nav')) {
    document.querySelector('.year-nav').innerText = data.yearItems.nav
  }
  if (document.querySelector('.year-discount')) {
    document.querySelector('.year-discount').innerText = data.yearItems.discount
  }
  if ( month > 2 ) {
    if (document.querySelector('.q1-premium')) {
      document.querySelector('.q1-premium').innerText = data.q1Items.premium
    }
    if (document.querySelector('.q1-nav')) {
      document.querySelector('.q1-nav').innerText = data.q1Items.nav
    }
    if (document.querySelector('.q1-discount')) {
      document.querySelector('.q1-discount').innerText = data.q1Items.discount
    }
  }
  if ( month > 5 ) {
    if (document.querySelector('.q2-premium')) {
      document.querySelector('.q2-premium').innerText = data.q2Items.premium
    }
    if (document.querySelector('.q2-nav')) {
      document.querySelector('.q2-nav').innerText = data.q2Items.nav
    }
    if (document.querySelector('.q2-discount')) {
      document.querySelector('.q2-discount').innerText = data.q2Items.discount
    }
  }
  if ( month > 8 ) {
    if (document.querySelector('.q3-premium')) {
      document.querySelector('.q3-premium').innerText = data.q3Items.premium
    }
    if (document.querySelector('.q3-nav')) {
      document.querySelector('.q3-nav').innerText = data.q3Items.nav
    }
    if (document.querySelector('.q3-discount')) {
      document.querySelector('.q3-discount').innerText = data.q3Items.discount
    }
  }

   if (data.items.length) {

        let Difference_In_Days_PY
        if ( data.items[0][0] > firstDayOfPrevYear) {
          firstDayOfPrevYear = data.items[0][0]
          Difference_In_Days_PY = Math.floor( ( firstDayOfCurrentYear - firstDayOfPrevYear ) / ( 1000 * 3600 * 24 ) )
        } else {
          Difference_In_Days_PY = Math.floor( ( firstDayOfCurrentYear - firstDayOfPrevYear ) / ( 1000 * 3600 * 24 ) ) - 1
        }

        const pdchart = Highcharts.stockChart(ChartBlock, {
          series: [{
            name: 'Дисконт/Премия',
            data: data.items,
            color: '#0BBA7C',
            pointInterval: 24 * 3600 * 1000
          }],
          // кнопки выбора периода
          rangeSelector: {
            allButtonsEnabled: true,
            verticalAlign: 'top',
            buttons: [{
              type: 'day',
              count: Difference_In_Days_PYTD,
              text: 'Previous Year to Date',
              events: {
                click: ()=> {
                  const xAxis = pdchart.xAxis[0]
                  let min = firstDayOfPrevYear
                  if (xAxis.dataMin > min) {
                    min = xAxis.dataMin
                  }
                  xAxis.setExtremes(min, now, true)
                  return true
                }
              }
            }, {
              type: 'day',
              count:Difference_In_Days_PY,
              text: 'Previous Year',
              events: {
                click: function(e) {
                  const xAxis = pdchart.xAxis[0]
                  let min = firstDayOfPrevYear
                  if (xAxis.dataMin > min) {
                    min = xAxis.dataMin
                  }
                  xAxis.setExtremes(min, firstDayOfCurrentYear)
                  return true
                }
              }
            }, {
              type: 'day',
              count: Difference_In_Days_PQ,
              text: 'Previous Quarter',
              events: {
                click: function(e) {
                  const xAxis = pdchart.xAxis[0]
                  xAxis.setExtremes(startOfPrevQ, endOfPrevQ, true, true)
                  return true
                }
              }
            }, {
              type: 'all',
              text: 'All',
            }],
            buttonTheme: {
              width: 'auto'
            },
            floating: true,
            inputEnabled: false,
            selected: 3,
            enabled: true,
            dropdown: 'never',
          },
          responsive: {
            rules: [{
              condition: {
                maxWidth: 650
              },
              chartOptions: {
                rangeSelector: {
                  buttonTheme: {
                    padding: 1,
                  },
                  inputPosition: {
                    y: -40,
                  },
                  buttonPosition: {
                    x: -25,
                    y: -40,
                    align: 'left'
                  },
                  buttons: [{
                    type: 'day',
                    count: Difference_In_Days_PYTD,
                    text: 'Prev. YTD',
                    events: {
                      click: ()=> {
                        const xAxis = pdchart.xAxis[0]
                        let min = firstDayOfPrevYear
                        if (xAxis.dataMin > min) {
                          min = xAxis.dataMin
                        }
                        xAxis.setExtremes(min, now, true)
                        return true
                      }
                    }
                  }, {
                    type: 'day',
                    count:Difference_In_Days_PY,
                    text: 'Prev. Year',
                    events: {
                      click: function(e) {
                        const xAxis = pdchart.xAxis[0]
                        let min = firstDayOfPrevYear
                        if (xAxis.dataMin > min) {
                          min = xAxis.dataMin
                        }
                        xAxis.setExtremes(min, firstDayOfCurrentYear)
                        return true
                      }
                    }
                  }, {
                    type: 'day',
                    count: Difference_In_Days_PQ,
                    text: 'Prev. Quarter',
                    events: {
                      click: function(e) {
                        const xAxis = pdchart.xAxis[0]
                        xAxis.setExtremes(startOfPrevQ, endOfPrevQ, true, true)
                        return true
                      }
                    }
                  }, {
                    type: 'all',
                    text: 'All',
                  }],
                }
              }
            },
            ],
          },
          // скрыть навигатор, скролбар и ссылку highcharts.com
          navigator: { enabled: false },
          scrollbar: { enabled: false },
          credits: { enabled: false },
          tooltip: {
            headerFormat: "",
            xDateFormat: "%d.%m.%Y",
            pointFormatter: function () {
              let t = this.y.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
                e = new Date(this.x).toLocaleDateString("ru-RU", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric"
                });
              return e = e[0].toUpperCase() + e.slice(1), "<b>".concat(e,'</b><br/><span style="color:').concat(this.series.color, '">').concat(this.series.name, ": <b>").concat(t, "</b></span><br/>")
            },
            split: !0
          },
          xAxis: {
            labels: {
              format: '{value:%e.%m.%Y}',
            },
            type: 'datetime'
          },
          yAxis: {
            opposite: false,
            title: {
              text: '%',
              align: 'high',
              y: 30
            },
            labels: {
              allowOverlap: true,
            }
          },
        })
      }

})
